/**
 * Created by sasik on 3/27/16.
 */

var format = 'DD.MM.YYYY';

$(function () {

    $('#coupon_from').datetimepicker({
            format: $('#coupon_from').is("[format]") ? $('#coupon_from').attr("format") : 'DD.MM.YYYY',
            locale: $('#coupon_from').is('[locale]') ? $('#coupon_from').attr("locale") : 'ru',
        allowInputToggle: true
        });


    $('#coupon_until').datetimepicker({
            format: $('#coupon_until').is("[format]") ? $('#coupon_until').attr("format") : 'DD.MM.YYYY',
            locale: $('#coupon_until').is('[locale]') ? $('#coupon_until').attr("locale") : 'ru',
        allowInputToggle: true
        });

    $("#coupon_from").on("dp.change", function (e) {
        $('#coupon_until').data("DateTimePicker").minDate(e.date);
    });
    $("#coupon_until").on("dp.change", function (e) {
        $('#coupon_from').data("DateTimePicker").maxDate(e.date);
    });

});
